var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.93037 12.4241C10.2166 12.4241 11.2593 13.4668 11.2593 14.753V19.4109C11.2593 20.6972 10.2166 21.7399 8.93037 21.7399C6.35788 21.7399 4.27246 19.6545 4.27246 17.082C4.27246 14.5095 6.35788 12.4241 8.93037 12.4241Z",
    fill: "url(#paint0_linear_4930_7617)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5751 12.4241C19.2889 12.4241 18.2462 13.4668 18.2462 14.753V19.4109C18.2462 20.6972 19.2889 21.7399 20.5751 21.7399C23.1476 21.7399 25.233 19.6545 25.233 17.082C25.233 14.5095 23.1476 12.4241 20.5751 12.4241Z",
    fill: "url(#paint1_linear_4930_7617)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16191 13.0333C5.44951 7.98592 9.63366 3.98158 14.7531 3.98158C19.8725 3.98158 24.0566 7.98591 24.3442 13.0333C23.3565 12.1134 22.0317 11.5507 20.5755 11.5507C18.8069 11.5507 17.3731 12.9844 17.3731 14.753V19.4109C17.3731 21.1795 18.8069 22.6132 20.5755 22.6132C22.0329 22.6132 23.3588 22.0495 24.3468 21.1282C24.3396 21.4178 24.3284 21.6768 24.3111 21.9128C24.2633 22.5633 24.1724 22.9691 24.0266 23.2931C23.6471 24.1363 22.9719 24.8115 22.1287 25.191C21.8047 25.3368 21.3989 25.4277 20.7484 25.4755C20.0891 25.5239 19.2496 25.5244 18.0673 25.5244H14.7531C14.2707 25.5244 13.8797 25.9154 13.8797 26.3978C13.8797 26.8801 14.2707 27.2711 14.7531 27.2711H18.1018C19.2419 27.2711 20.1456 27.2711 20.8763 27.2175C21.623 27.1627 22.2577 27.0484 22.8456 26.7838C24.078 26.2291 25.0647 25.2424 25.6194 24.01C25.884 23.4221 25.9983 22.7874 26.0531 22.0407C26.1067 21.31 26.1067 20.4064 26.1067 19.2662V13.5885C26.1067 7.31807 21.0235 2.23486 14.7531 2.23486C8.48262 2.23486 3.39941 7.31807 3.39941 13.5885V17.0819C3.39941 20.1368 5.87585 22.6132 8.93068 22.6132C10.6993 22.6132 12.133 21.1795 12.133 19.4109V14.753C12.133 12.9844 10.6993 11.5507 8.93068 11.5507C7.47445 11.5507 6.14966 12.1134 5.16191 13.0333ZM5.14613 17.0819C5.14613 19.1721 6.84053 20.8665 8.93068 20.8665C9.73458 20.8665 10.3863 20.2148 10.3863 19.4109V14.753C10.3863 13.9491 9.73458 13.2974 8.93068 13.2974C6.84053 13.2974 5.14613 14.9918 5.14613 17.0819ZM24.36 17.0819C24.36 14.9918 22.6656 13.2974 20.5755 13.2974C19.7715 13.2974 19.1199 13.9491 19.1199 14.753V19.4109C19.1199 20.2148 19.7715 20.8665 20.5755 20.8665C22.6656 20.8665 24.36 19.1721 24.36 17.0819Z",
    fill: "url(#paint2_linear_4930_7617)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4930_7617",
    x1: 14.7528,
    y1: 12.4241,
    x2: 14.7528,
    y2: 21.7399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4930_7617",
    x1: 14.7528,
    y1: 12.4241,
    x2: 14.7528,
    y2: 21.7399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4930_7617",
    x1: 14.7531,
    y1: 2.23486,
    x2: 14.7531,
    y2: 27.2711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/headset.0ab57100a89fab969ca2ad9bd9646c8a.svg";
export { ForwardRef as ReactComponent };